export default __webpack_public_path__ + "static/media/bulleted-list-svgrepo-com.0fa470f7.svg";